import { PixKeyTypeSchema } from '@doutorsim/shared/bank-accounts'
import type { TExposedFacilityDTO } from '@doutorsim/shared/facilities'
import { BaseFacilityDTOSchema } from '@doutorsim/shared/facilities'
import { zodResolver } from '@hookform/resolvers/zod'
import type { ReactNode } from 'react'
import { FormProvider as _FormProvider, useForm } from 'react-hook-form'
import { z } from 'zod'

const FacilitySettingsFormSchema = BaseFacilityDTOSchema.pick({
  name: true,
  cnpj: true,
}).extend({
  legalName: z.string().min(2).max(128),
  phone: z.string().nullable(),
  email: z.email().nullable(),
  bankCode: z.string().nullable().optional(),
  branchNumber: z.string().nullable().optional(),
  accountNumber: z.string().nullable().optional(),
  pixKey: z.string().nullable().optional(),
  pixKeyType: PixKeyTypeSchema.nullable().optional(),
})

export type TFacilitySettingsFormValues = z.infer<typeof FacilitySettingsFormSchema>

interface FormProviderProps {
  facility: TExposedFacilityDTO
  children: ReactNode
}

export const FormProvider = ({ facility, children }: FormProviderProps) => {
  const methods = useForm<TFacilitySettingsFormValues>({
    resolver: zodResolver(FacilitySettingsFormSchema),
    shouldUnregister: false,
    defaultValues: {
      name: facility.name,
      legalName: facility.legalName ?? null,
      cnpj: facility.cnpj,
      phone: facility.contactInfo?.phone ?? null,
      email: facility.contactInfo?.email ?? null,
      bankCode: facility.bankAccount?.bankCode ?? null,
      branchNumber: facility.bankAccount?.branchNumber ?? null,
      accountNumber: facility.bankAccount?.accountNumber ?? null,
      pixKey: facility.bankAccount?.pixKey ?? null,
      pixKeyType: facility.bankAccount?.pixKeyType ?? null,
    },
  })

  return <_FormProvider {...methods}>{children}</_FormProvider>
}
